"use strict";

window.SatisfactionAPI = new (function () {

    var self = this;
    var _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration.getBaseAPI("SatisfactionServer"));

    self.getEmployeeSatisfaction = function (groupId, brandId, period, userId) {

        var deferred = $q.defer();

        var params = {
            trend_period_filter_type: period,
            user_ids: userId
        };

        _protected.request("brands/" + groupId + "/team_live/employee_satisfaction/brands/" + brandId + "/employee_card", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            });

        return deferred.promise;
    };

    self.getTeamSatisfaction = function (groupId, brandId) {

        var deferred = $q.defer();

        _protected.request("brands/" + groupId + "/team_live/employee_satisfaction/brands/" + brandId + "/team_card", "GET")
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            });

        return deferred.promise;
    };


    self.getBrandSatisfactionModel = function (groupId, brandId) {
        var deferred = $q.defer();

        _protected.request("brands/" + groupId + "/team_live/employee_satisfaction/brands/" + brandId + "/summary", "GET")
            .then(function (res) {
                if (res.data && res.data.data) {
                    deferred.resolve(res.data.data.brands);
                } else {
                    deferred.reject(res);
                }
            });

        return deferred.promise;
    };

});